var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardForm',{attrs:{"titulo":_vm.titleCard}},[_c('DataList',{ref:"datatable",staticClass:"mb-3",attrs:{"url":"user","fields":_vm.fields,"toCuil":_vm.toCuil,"rowClick":_vm.opciones}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }